import './TopBarLanding.css';
// import wagerwizlogoname from '../../assets/images/wagerwiz_logo_and_name.svg';
import wagerwizlogo_desktop from '../../assets/WagerWiz_OnDark_Vector.svg';
import { useEffect, useState } from 'react';
import { LoginButton } from '../../components/LoginButton/LoginButton';
import MenuIcon from '@mui/icons-material/Menu';
import IconButton from '@mui/material/IconButton';
import Drawer from '@mui/material/Drawer';
import List from '@mui/material/List';
import ListItem from '@mui/material/ListItem';
import ListItemText from '@mui/material/ListItemText';
import Button from '@mui/material/Button';
import Box from '@mui/material/Box';

export const TopBarLanding = (props) => {
	const { setIsSigningUp, scrollToRegion } = props;

	const [isMobile, setIsMobile] = useState(window.innerWidth <= 750);

	useEffect(() => {
		const handleResize = () => {
			setIsMobile(window.innerWidth <= 750);
		};
		window.addEventListener('resize', handleResize);
		return () => window.removeEventListener('resize', handleResize);
	}, []);

	return (
		<div style={{ backgroundColor: '#17191d' }}>
			<div style={{ minHeight: '72px', borderBottom: '1px solid #303033', color: 'white' }} className="flex flex-row">
				{/* <img className={`${!isMobile ? 'pl-12' : 'pl-2'} cursor-pointer`} src={wagerwizlogoname} alt="wagerwiz logo" /> */}
				<div className="flex flex-row cursor-pointer" style={{ color: 'white', fontFamily: 'Poppins' }}>
					{!isMobile && (
						<a href="/" className="ml-4" style={{ lineHeight: 0 }} aria-label="WagerWiz home">
							<img src={wagerwizlogo_desktop} alt="wager wiz logo" height={225} width={225} />
						</a>
					)}
					{/* {isMobile && <img className="ml-4" src={wagerwizlogonew} alt="wager wiz logo" height={15} width={40} />} */}
					{isMobile && (
						<div style={{ marginLeft: 'auto', marginTop: 'auto', marginBottom: 'auto', cursor: 'pointer' }}>
							<HamburgerMenu left={true} />
						</div>
					)}
				</div>
				{!isMobile && (
					<>
						<nav className="flex flex-row" style={{ marginLeft: 'auto', marginRight: 'auto', alignItems: 'center' }} aria-label="Main">
							<a href="/" className="cursor-pointer mr-8" style={{ color: 'inherit', textDecoration: 'none' }}>
								Home
							</a>
							<a
								href="/#features"
								onClick={() => {
									setTimeout(() => scrollToRegion?.(), 0);
								}}
								className="cursor-pointer mr-8"
								style={{ color: 'inherit', textDecoration: 'none' }}>
								Features
							</a>
							<a href="/pricing" className="cursor-pointer mr-8" style={{ color: 'inherit', textDecoration: 'none' }}>
								Pricing
							</a>
							<a href="/ev-scanner" className="cursor-pointer mr-8" style={{ color: 'inherit', textDecoration: 'none' }}>
								EV Scanner
							</a>
							<a href="/screener" className="cursor-pointer mr-8" style={{ color: 'inherit', textDecoration: 'none' }}>
								Screener
							</a>
							<a href="/tools" className="cursor-pointer mr-8" style={{ color: 'inherit', textDecoration: 'none' }}>
								Tools
							</a>
							<a href="/blog" className="cursor-pointer" style={{ color: 'inherit', textDecoration: 'none' }}>
								Blog
							</a>
						</nav>
						<div style={{ alignSelf: 'center' }} className="pl-2">
							<LoginButton />
						</div>
						<div
							onClick={() => {
								setIsSigningUp(true);
							}}
							className="signup-button"
							style={{
								marginLeft: '18px',
								marginRight: '18px',
								alignItems: 'center',
								backgroundColor: '#287eff',
								alignContent: 'center',
								padding: '8px',
								borderRadius: '8px',
								height: 'fit-content',
								cursor: 'pointer',
								marginTop: 'auto',
								marginBottom: 'auto',
							}}>
							<div>Sign up</div>
						</div>
					</>
				)}
				{
					isMobile && <div style={{marginLeft: "auto"}} className='flex flex-row'>
						<ListItem>
								<LoginButton />
							</ListItem>
							<ListItem>
								<Button style={{width: "max-content"}} color="primary" variant="contained" onClick={() => setIsSigningUp(true)}>
									Sign Up
								</Button>
							</ListItem>
						</div>
				}
			</div>
		</div>
	);
};

function HamburgerMenu({ left }) {
	const [open, setOpen] = useState(false);

	const toggleDrawer = (state) => () => {
		setOpen(state);
	};

	return (
		<>
			<IconButton onClick={toggleDrawer(true)} color="inherit">
				<MenuIcon />
			</IconButton>
			<Drawer
				sx={{ '& .MuiPaper-root': { height: 'fit-content', borderTopLeftRadius: 6, borderBottomLeftRadius: 6 } }}
				anchor={left ? 'left' : 'right'}
				open={open}
				onClose={toggleDrawer(false)}>
				<Box
					sx={{
						backgroundColor: '#17191e',
						color: 'white',
					}}
					role="presentation"
					onClick={toggleDrawer(false)}>
					<List component="nav" aria-label="Main">
						<ListItem button component="a" href="/">
							<ListItemText className="cursor-pointer" primary="Home" />
						</ListItem>
						<ListItem button component="a" href="/#features">
							<ListItemText className="cursor-pointer" primary="Features" />
						</ListItem>
						<ListItem button component="a" href="/pricing">
							<ListItemText className="cursor-pointer" primary="Pricing" />
						</ListItem>
						<ListItem button component="a" href="/ev-scanner">
							<ListItemText className="cursor-pointer" primary="EV Scanner" />
						</ListItem>
						<ListItem button component="a" href="/screener">
							<ListItemText className="cursor-pointer" primary="Screener" />
						</ListItem>
						<ListItem button component="a" href="/tools">
							<ListItemText className="cursor-pointer" primary="Tools" />
						</ListItem>
						<ListItem button component="a" href="/blog">
							<ListItemText className="cursor-pointer" primary="Blog" />
						</ListItem>
						{/* <ListItem>
							<LoginButton />
						</ListItem>
						<ListItem>
							<Button color="primary" variant="contained" onClick={() => setIsSigningUp(true)}>
								Sign Up
							</Button>
						</ListItem> */}
					</List>
				</Box>
			</Drawer>
		</>
	);
}
